module.exports = __webpack_public_path__ + "static/media/pr.1418c1d3.svg";